<template>
  <div>

    <h4>Resumo</h4>
    <div class="w-full vx-row m-0 p-3 border border-solid d-theme-border-grey-light rounded relative ">
      <div v-for="order in orders" :key="order.id"
        class="my-2 md:w-4/12">
        <order-item :order="order">
          <div class="" slot="actions">
            <vs-dropdown vs-trigger-click style="z-index: 9999991">
              <vs-button 
                  size="small" 
                  class="btn-drop"
                  type="filled" 
                  icon="expand_more" >
              </vs-button>
              <vs-dropdown-menu style="z-index: 9999999">
                  <vs-dropdown-item class="mb-2" @click="removeOrder(order)"> <a-icon type="delete" /> REMOVER </vs-dropdown-item>
                  <vs-dropdown-item class="mb-2" @click="editOrder(order)"> <a-icon type="edit" /> EDITAR </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </order-item>
      </div>
      <span v-show="!orders.length"> Sem pedidos </span>
    </div>

    <vs-row class="my-8">
      <div class="md:w-6/12 pr-4">
        <h5>Nome do cliente</h5>
        <vs-input v-model="name"
          v-validate.initial="{required : true, min: 3}" name="Nome"
          class="w-full" />
        <span class="text-danger text-sm" v-show="errors.has('Nome')">{{ errors.first('Nome') }}</span>
      </div>
      <div class="md:w-6/12 pl-4">
        <h5>Telefone</h5>
        <vs-input 
          v-mask="'(##) # #### ####'"
          v-model="telephone"
          name="Telefone"
          class="w-full" />
        <span class="text-danger text-sm" v-show="errors.has('Telefone')">{{ errors.first('Telefone') }}</span>
      </div>
    </vs-row>

    <vs-divider class="my-8"/>

    <h5>Forma de pagamento</h5>
    <div class="flex mt-4" style="justify-content: space-between;">
      <vs-radio v-for="type in Object.values(paymentTypes)" :key="type.value"
        v-model="paymentType" :vs-value="type.value" class="mt-2 mr-4">{{ type.description }}</vs-radio>
      <div :class="{ 'fade': !isCash }">
        <h6>Troco para</h6>
        
        <money 
          v-bind="{
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                precision: 2,
                masked: false
          }"
          v-model="change" 
          :disabled="!isCash"
          class="vs-inputx vs-input--input normal" style="border: 1px solid rgba(0, 0, 0, 0.2);"/>
      </div>
    </div>

    <vs-divider class="my-8"/>

    <h6>Observações gerais</h6>
    <a-textarea v-model="obs"
      class="mt-2"
      :auto-size="{ minRows: 3, maxRows: 5 }"/>

    <a-modal
      :maskClosable="true"
      :width="900"
      :zIndex="90000"
      :footer="null"
      :title="`Editar ${modalEditOrder.editingOrder && modalEditOrder.editingOrder.product.description}`"
      destroyOnClose
      v-model="modalEditOrder.visible">

      <product-options
        :productId="modalEditOrder.editingOrder && modalEditOrder.editingOrder.product.id"
        :editingOrder="modalEditOrder.editingOrder"
        @saved="modalEditOrder.visible = false"/>

    </a-modal>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';
  import OrderItem from './OrderItem';
  import ProductOptions from '@/components/product/OrderProductOptions';
  import {mask} from 'vue-the-mask'

  export default {
    directives : {mask},

    components: {
      OrderItem,
      ProductOptions
    },
    data() {
      return {
        paymentTypes: {
          'credit_card': { description: 'Cartão de Crédito', value: 'credit_card' },
          'debit_card': { description: 'Cartão de Débito', value: 'debit_card' },
          'money': { description: 'Dinheiro', value: 'money' }
        },
        modalEditOrder: {
          visible: false,
          editingOrder: null
        }
      }
    },
    computed: {
      isCash () {
        return this.paymentType === 'money';
      },
      paymentType: {
        get () {
          return this.payment.paymentType;
        },
        set (v) {
          this.setPaymentType(v);
          this.$emit('changePayment', this.paymentTypes[v].description);
        }
      },
      name: {
        get () {
          return this.clientName;
        },
        set (val) {
          this.$emit('valid', val.length > 3)
          this.setClientName(val);
        }
      },
      telephone: {
        get () {
          return this.payment.phoneNumber;
        },
        set (val) {
          // this.$emit('valid', val.length > 5)
          this.setClientTelephone(val);
        }
      },
      change: {
        get () {
          return this.payment.chageFor;
        },
        set (val) {
          this.setChange(val);
        }
      },
      obs: {
        get () {
          return this.payment.obs;
        },
        set (val) {
          this.setObs(val);
        }
      },
      ...mapState('delivery', ['clientName', 'payment', 'orders'])
    },
    methods: {
      editOrder (order) {
        this.modalEditOrder.visible = true;
        this.modalEditOrder.editingOrder = order;
      },
      removeOrder (order) {
        this.$confirm({
          zIndex: 9999999,
          title: 'Remover item',
          content: `Deseja realmente remover o item "${order.product.description}"?`,
          okText: 'Remover',
          okType: 'danger',
          cancelText: 'Não',
          onOk: () => {
            this.removeItem(order);
          },
        });
      },
      ...mapMutations('delivery', ['setPaymentType', 'setClientName', 'setChange', 'setClientTelephone','setObs', 'removeItem'])
    },
    mounted () {
      this.paymentType = 'credit_card';
    },
  }
</script>

<style lang="scss" scoped>
.fade {
  opacity: 0.5;
}
.badge {
  position: absolute;
  top: -2px;
  right: 5px;
}
</style>